/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { Configuration, LogLevel } from "@azure/msal-browser";
// if(window.location.hostname == 'project-portfolio-dev.pttep.com')
// {
//     clientId = "8f169b85-e91d-468a-81b3-fee8bccd43fe"
// }
// if(window.location.hostname == 'project-portfolio-qas.pttep.com')
// {
//     clientId = "94b6c4fc-6352-4647-81f0-8d3a044ab36d"
// }
// if(window.location.hostname == 'project-portfolio-uat.pttep.com')
// {
//     clientId = "8f169b85-e91d-468a-81b3-fee8bccd43fe"
// }
/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

export const msalConfig: Configuration = {
    auth: {
        clientId: "",
        authority: "https://login.microsoftonline.com/{tenantId}",
        redirectUri: "/",
        postLogoutRedirectUri: '/'
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                       // console.error(message);
                        return;
                    case LogLevel.Info:
                      //  console.info(message);
                        return;
                    case LogLevel.Verbose:
                       // console.debug(message);
                        return;
                    case LogLevel.Warning:
                       // console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/master/lib/msal-browser/docs/resources-and-scopes.md
*/
export const apiRequest = {
    scopes: ["api://{clientId}/read_user_profile"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "Enter_the_Graph_Endpoint_Herev1.0/me"
};
